import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotator = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
`;

const colors = keyframes`
	0% { stroke: #8884d8; }
	25% { stroke: #DE3E35; }
	50% { stroke: #F7C223; }
	75% { stroke: #1B9A59; }
  100% { stroke: #8884d8; }
`;

const colorsText = keyframes`
	0% { color: #8884d8; }
	25% { color: #DE3E35; }
	50% { color: #F7C223; }
	75% { color: #1B9A59; }
  100% { color: #8884d8; }
`;

const dash = keyframes`
 0% { stroke-dashoffset: 187; }
 50% {
   stroke-dashoffset: 187/4;
   transform:rotate(135deg);
 }
 100% {
   stroke-dashoffset: 187;
   transform:rotate(450deg);
 }
`;

const WrapperSpinner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    animation: ${rotator} 1.4s linear infinite;
    margin-bottom: 2rem;
  }
  svg circle {
    stroke-dasharray: 187;
    stroke-dashoffset: 110;
    transform-origin: center;
    animation: ${colors} 5.6s ease-in-out infinite,
    ${dash} 1.4s ease-in-out infinite;
  }
`

  const Text = styled.div`
    animation: ${colorsText} 5.6s ease-in-out infinite;
    font-size: 1.4em;
    letter-spacing: 0.25em;
  `

export default function PageTickets() {

  return (
    <WrapperSpinner>
      <svg width="130" height="130" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
       <circle fill="none" strokeWidth="9" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
      </svg>
      <Text>Loading</Text>
    </WrapperSpinner>
  )
}